import React from 'react';
import './Header.css';
import Cookies from 'js-cookie';
import { FaUser, FaSignOutAlt, FaUserCircle, FaMoon, FaSun, FaSearch } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const useDarkMode = () => {
  const [isDark, setIsDark] = React.useState(() => {
    const saved = localStorage.getItem('theme');
    return saved === 'dark';
  });

  React.useEffect(() => {
    document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light');
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
  }, [isDark]);

  return [isDark, () => setIsDark(d => !d)];
};

const Header = () => {
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [isDark, toggleDark] = useDarkMode();
  const token = Cookies.get('jwtToken');
  const username = Cookies.get('username');
  const navigate = useNavigate();

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const handleLogout = () => {
    Cookies.remove('jwtToken');
    Cookies.remove('username');
    Cookies.remove('userRole');
    Cookies.remove('name');
    window.location.href = '/';
  };

  return (
    <header className="site-header">
      {/* Logo Section */}
      <a href="/" className="home-link">
        <div className="header-logo">
          <img src="/logo.png" alt="Digital Journaling" />
          <h1>Digital Journaling</h1>
        </div>
      </a>

      {/* Right controls: search + dark mode + hamburger */}
      <div className="header-controls">
        {/* <button className="icon-btn" onClick={() => navigate('/search')} aria-label="Search">
          <FaSearch />
        </button> */}
        <button className="icon-btn dark-toggle" onClick={toggleDark} aria-label="Toggle dark mode">
          {isDark ? <FaSun /> : <FaMoon />}
        </button>
        <button className={`menu-toggle ${menuOpen ? 'open' : ''}`} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {/* Navigation */}
      <nav className={`nav-menu ${menuOpen ? 'open' : ''}`}>
        <ul>
          <li><a onClick={() => { navigate("/"); setMenuOpen(false); }}>Home</a></li>
          <li><a onClick={() => { navigate("/about"); setMenuOpen(false); }}>About</a></li>
          <li><a onClick={() => { navigate("/privacy"); setMenuOpen(false); }}>Privacy</a></li>
          <li><a onClick={() => { navigate("/contact"); setMenuOpen(false); }}>Contact</a></li>

          {token && username ? (
            <li className="dropdown">
              <a className="user-link">
                <FaUserCircle className="user-icon" /> {username}
              </a>
              <div className="dropdown-content">
                <a onClick={() => { navigate("/profile"); setMenuOpen(false); }}>
                  <FaUser /> Profile
                </a>
                <a onClick={handleLogout}>
                  <FaSignOutAlt /> Logout
                </a>
              </div>
            </li>
          ) : (
            <>
              <li><a onClick={() => { navigate("/login"); setMenuOpen(false); }}>Login</a></li>
              <li><a onClick={() => { navigate("/register"); setMenuOpen(false); }}>Register</a></li>
            </>
          )}
        </ul>
      </nav>
    </header>
  );
};

export default Header;

